import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-orientation-popup',
  templateUrl: './orientation-popup.component.html',
  styleUrls: ['./orientation-popup.component.css']
})
export class OrientationPopupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
